import { useState } from 'react'

import { useGetCompanySettingsQuery } from '../../app/apiSlice'
import { AdminPage, AdminPageHeader, AdminSection } from '../../common/components'
import { Select, Text } from '../../common/designs'
import CompanyDataGraph from './CompanyDataGraph'
import TeamsDataGraph from './TeamsDataGraph'

const AgentMonitoring = () => {
  const [daysSelected, setDaysSelected] = useState<number>(7)
  const [diffWithDate, setDiffWithDate] = useState('')
  const { data: companySettings } = useGetCompanySettingsQuery(null)

  return (
    <AdminPage width='full'>
      <AdminPageHeader
        title='Computer Connectivity'
        description='Review company and team-level desktop agent connectivity over time.'
        actions={
          <Select
            value={daysSelected}
            options={[
              { label: 'Last 3 Days', value: 3 },
              { label: 'Last 7 Days', value: 7 },
              { label: 'Last 14 Days', value: 14 },
              { label: 'Last 30 Days', value: 30 },
              { label: 'Last 60 Days', value: 60 },
              { label: 'Last 90 Days', value: 90 },
            ]}
            onChange={(days: number) => setDaysSelected(days)}
          />
        }
      />

      <div className='mt-8 space-y-6'>
        <div>
          <CompanyDataGraph
            daysSelected={daysSelected}
            diffWithDate={diffWithDate}
            onDiffWithDateChange={setDiffWithDate}
            expectedCompanyTarget={companySettings?.agent_installation_target}
          />
        </div>

        <AdminSection className='space-y-3'>
          <Text size='s' color='lightGray' className='leading-relaxed'>
            Team-level charts are shown below and can be compared against expected installation
            targets.
          </Text>
          <div className='-m-2'>
            <TeamsDataGraph
              daysSelected={daysSelected}
              diffWithDate={diffWithDate}
              onDiffWithDateChange={setDiffWithDate}
            />
          </div>
        </AdminSection>
      </div>
    </AdminPage>
  )
}

export default AgentMonitoring
